export default "/36022bc732d21dcfe768d2a0d43278c292b1a1e5/c149c2995e67c98d8198109bf15793c7.svg";